import { render } from "./BreathTrainer.vue?vue&type=template&id=4b11b223&scoped=true"
import script from "./BreathTrainer.vue?vue&type=script&lang=js"
export * from "./BreathTrainer.vue?vue&type=script&lang=js"

import "./BreathTrainer.vue?vue&type=style&index=0&id=4b11b223&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b11b223"]])

export default __exports__